'use strict';

// FastAction Databag
define('fast_databag',['databag'], function(Databag) {
  return new Databag({name: 'fastaction'});
});

